export const UrlConst = ["$param1$", "$param2$", "$param3$", "$param4$", "$param5$", "$param6$", "$param7$", "$param8$", "$param9$"];
